import { DatePicker } from 'antd';
import styled from 'styled-components';

export const InputStyle = styled(DatePicker)`
  border-radius: 5px;

  height: 45px;
  width: 100%;
  padding: 15px;

  background: #fcfcfc;
  color: rgba(0, 0, 0, 0.5);
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  padding: 6px 0;
  font-weight: 300;
`;

export const Icone = styled('button')<{
  error: string | null | undefined;
}>`
  display: flex;
  align-items: center;

  background: #fcfcfc;
  border-radius: 0 5px 5px 0;
  border-left: 0 !important;
  ${props => props.error && 'border: 1px solid #DF0A24;'}

  height: 45px;
  padding: 15px;

  font-size: 25px;
`;

export const ErroAlert = styled('p')<{ erro: boolean }>`
  margin-top: 4px;
  color: #df0a24;
  font-size: 10px;
  min-height: 16px;

  ${props => !props.erro && `display: none`}
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100% !important;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.13);
  margin: 10px 0;
`;
